import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent } from "@/lib/analytics";
import { Cookie } from "lucide-react";

export default function CookieNotice() {
  const [choice, setChoice] = useState(getConsent());
  if (choice) return null;

  const decide = (v) => {
    setConsent(v);
    setChoice(v);
  };

  return (
    <div
      data-testid="cookie-notice"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-xl border border-white/15 bg-[#121212]/95 backdrop-blur-xl p-5 shadow-2xl"
    >
      <div className="flex items-center gap-2">
        <Cookie className="h-4 w-4 text-[#FF9F0A]" />
        <span className="font-bold text-white text-sm">Cookies &amp; privacy</span>
      </div>
      <p className="mt-2 text-xs text-neutral-400 leading-relaxed">
        We use essential cookies to keep you signed in. With your OK, we also count anonymous
        first-party page views to improve VISMARKS — no third-party ad trackers, ever.{" "}
        <Link to="/privacy" className="text-[#007AFF] hover:underline">Privacy Policy</Link>
      </p>
      <div className="mt-4 flex gap-2">
        <Button
          data-testid="cookie-accept-btn"
          onClick={() => decide("all")}
          className="flex-1 rounded-full h-9 bg-white text-black hover:bg-neutral-200 font-semibold text-xs"
        >
          Accept all
        </Button>
        <Button
          data-testid="cookie-essential-btn"
          onClick={() => decide("essential")}
          variant="outline"
          className="flex-1 rounded-full h-9 bg-transparent border-white/20 text-white hover:bg-white/5 hover:text-white font-semibold text-xs"
        >
          Essential only
        </Button>
      </div>
    </div>
  );
}
